export default function InventoryAutomation() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="mb-12">
          <div className="inline-block bg-primary text-white px-6 py-3 rounded-lg font-bold text-lg mb-4">
            ⑤ 在庫管理の自動化
          </div>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-12">
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">在庫ズレの原因</h3>
            <ul className="space-y-4">
              {[
                { icon: 'ri-time-line', text: 'FBA反映遅れ', color: 'text-red-500' },
                { icon: 'ri-store-line', text: '多モール販売', color: 'text-orange-500' },
                { icon: 'ri-error-warning-line', text: '手動更新忘れ', color: 'text-yellow-600' }
              ].map((item, index) => (
                <li key={index} className="flex items-start gap-3 bg-gray-50 rounded-lg p-4">
                  <i className={`${item.icon} text-2xl ${item.color} mt-1`}></i>
                  <span className="text-gray-700 font-medium">{item.text}</span>
                </li>
              ))}
            </ul>
          </div>
          
          <div className="bg-primary/5 border-2 border-primary rounded-2xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-primary mb-6">自動化構成</h3>
            <div className="space-y-4">
              <div className="bg-white rounded-xl p-6 text-center">
                <div className="font-bold text-gray-900 text-lg mb-2">Amazon在庫</div>
                <i className="ri-arrow-down-line text-3xl text-primary"></i>
              </div>
              <div className="bg-white rounded-xl p-6 text-center">
                <div className="font-bold text-gray-900 text-lg mb-2">SP-API</div>
                <i className="ri-arrow-down-line text-3xl text-primary"></i>
              </div>
              <div className="bg-white rounded-xl p-6 text-center">
                <div className="font-bold text-gray-900 text-lg mb-2">Google Sheets</div>
                <i className="ri-arrow-down-line text-3xl text-primary"></i>
              </div>
              <div className="bg-white rounded-xl p-6 text-center">
                <div className="font-bold text-gray-900 text-lg">他モール在庫</div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="bg-white rounded-2xl p-8 shadow-lg">
          <h3 className="text-2xl font-bold text-gray-900 mb-8">在庫0になったら：</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-gradient-to-br from-red-50 to-red-100 border-2 border-red-200 rounded-xl p-6">
              <div className="w-12 h-12 bg-red-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-stop-circle-line text-2xl text-white"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">自動出品停止</h4>
              <p className="text-sm text-gray-600">在庫切れを即座に反映</p>
            </div>
            
            <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 border-2 border-yellow-200 rounded-xl p-6">
              <div className="w-12 h-12 bg-yellow-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-notification-line text-2xl text-white"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">自動アラート</h4>
              <p className="text-sm text-gray-600">担当者に即座に通知</p>
            </div>
            
            <div className="bg-gradient-to-br from-primary/10 to-primary/20 border-2 border-primary rounded-xl p-6">
              <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center mb-4">
                <i className="ri-shopping-cart-line text-2xl text-white"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">自動仕入れ通知</h4>
              <p className="text-sm text-gray-600">発注タイミングを提案</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
